import React from 'react';
import './Dot.css';

const Dot: React.FC = () => <span className="dot">.</span>;

export default Dot;
